window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var cfg = ns.config;
  var st = ns.state;
  var utils = ns.utils;
  var dataModule = ns.data;
  var resolve = ns.resolve;

  var roomBackgroundUrl = window.EM.roomImages.backgroundUrl;
  var calendarReturnUrl = null;

  function buildCalendarReturnUrl(date) {
    var returnState = $.extend(true, {}, st.get());
    returnState.action = "calendar";
    returnState.start = date;
    returnState.date = cfg.DEFAULT_STATE.date;
    returnState.time = null;
    returnState.end = null;
    return cfg.PAGE_CALENDAR + ns.url.queryFromState(returnState);
  }

  function findCustomFieldInfo(room, customName) {
    var list = room && room.customFieldInfo;
    if (!list || !customName) return null;
    var key = String(customName).trim().toLowerCase();
    if (!key) return null;
    for (var i = 0; i < list.length; i++) {
      var entry = list[i];
      if (entry && String(entry.name || "").trim().toLowerCase() === key) {
        return entry;
      }
    }
    return null;
  }

  function openCustomFieldInfoModal(info) {
    var $modal = $("#custom-field-info-modal");
    if ($modal.length === 0 || !info) return;
    $modal.find(".modal-title").text(info.question || "");
    $modal.find(".modal-body").html(info.answer || "");
    $modal.modal("show");
  }

  function getExistingSlotPlayers(slot) {
    var existing = resolve.resolveExistingPlayers(slot.data, slot.event.reservation.slot, slot.data.free);
    return Number.isFinite(existing) ? existing : 0;
  }

  function buildSharedSlotNotice(slot) {
    // Gate with the same helper cart/checkout use (shouldShowPairingNotice),
    // then show the headcount in the copy.
    if (!ns.resolve.shouldShowPairingNotice(slot.room, slot.data && slot.data.orders)) {
      return "";
    }

    var existingPlayers = getExistingSlotPlayers(slot);
    if (existingPlayers <= 0) {
      return "";
    }

    var guestLabel = existingPlayers === 1 ? slot.room.playerValue || "guest" : slot.room.playerValuePlural || "guests";
    var notice =
      "This time slot already has <strong>" + existingPlayers + " " + guestLabel + "</strong> booked.";
    if (slot.room.private !== false) {
      notice += " Your booking will not be private and you will be paired with other guests.";
    } else {
      notice += " You will be paired with other guests.";
    }
    return notice;
  }

  function showBook(opt) {
    var state = st.get();
    opt = $.extend(true, {}, { refreshHtmlOnly: false, skipUpdateUrl: false }, opt);

    if (cfg.isLoungeHome) {
      state.action = "book";
      ns.url.updateUrl(cfg.PAGE_BOOK).then(function () {
        window.location.reload();
      });
      return;
    }

    var $book = $(".booking-form");
    var $players = $book.find(".form-players");
    var players = parseInt($players.val()) || parseInt(state.players) || 0;
    var slot = dataModule.getSelectedTimeSlot();

    if (slot === null || slot.location === null || slot.data === null || slot.event === null) {
      if (DEVELOPMENT === false && typeof Sentry !== "undefined") {
        Sentry.captureException(new Error("showBook: slot.location is null"), {
          extra: { state: state, locations: locations },
        });
      }
      setTimeout(function () {
        window.location = cfg.PAGE_CALENDAR;
      }, 3000);
      return;
    }

    var selectedEventId = resolve.resolveSelectedEventId(state.event, slot.event);
    var roomName = resolve.resolveReservationName(slot.event, selectedEventId);
    var price = (slot.event.prices.taxIncluded ? slot.event.prices.total : slot.event.prices.price) || 0;
    var freeBeyond = dataModule.resolveMinPlayersFixedPrice(slot.room, selectedEventId) || 0;
    var billable = freeBeyond > 0 ? Math.min(players, freeBeyond) : players;
    var amount = utils.round10(billable * price);

    var bookNotes = [];

    var slotSizes = resolve.resolveSlotGroupSize(slot.data, slot.event.reservation.slot);
    var minimumNumber = slotSizes.minGroupSize;
    var privateRoomPlayers = resolve.resolvePrivateThreshold(slot.room, slotSizes.maxGroupSize);

    if (slot.data.free < minimumNumber) {
      st.reset();
      ns.url.updateUrl(cfg.PAGE_CALENDAR);
      ns.calendar.showCalendar();
      return;
    }

    utils.hideAlert();

    if (opt.refreshHtmlOnly === false) {
      window.scrollTo(0, 0);
    }

    if (price === 0) {
      $(".hide-free").hide();
    } else {
      $(".hide-free").show();
    }

    $book.find(".book-image").css({ "background-image": "url('" + roomBackgroundUrl(slot.event.room) + "')" });

    var room = dataModule.getRoomByEventId(slot.event.venue.id, slot.event.reservation.id);
    $book.find(".book-info").html(room.shortText);

    $book.find(".book-price").html(utils.formatPrice(price));

    $book.find(".book-room-name").text(roomName);
    $book.find(".book-date-long").text(utils.formatDateAsLong(state.date));
    if (room.time && Number.isInteger(room.time)) {
      $book.find(".book-time").text(utils.formatTime(state.time) + "(" + room.time + "min)");
    } else if (room.time) {
      $book.find(".book-time").text(utils.formatTime(state.time) + "(" + room.time + ")");
    } else {
      $book.find(".book-time").text(utils.formatTime(state.time));
    }
    $book.find(".book-amount").text(utils.formatPrice(amount));

    $book.find(".book-business-name").text(slot.location.businessName);
    $book.find(".book-address").text([slot.location.address.streetAddress, slot.location.address.addressLocality, slot.location.address.addressRegion].join(", "));
    $book
      .find(".book-address-html")
      .html(slot.location.address.streetAddress + "<br/>" + slot.location.address.addressLocality + ", " + slot.location.address.addressRegion + " " + slot.location.address.postalCode);
    $book.find(".book-phone").text(slot.location.address.telephone);
    $book.find(".book-map").css({ backgroundImage: "url(/images/" + slot.location.mapImage + ")" });

    if (slot.room.bookNote) {
      bookNotes.push(slot.room.bookNote);
    }

    if (opt.refreshHtmlOnly === false) {
      if (typeof fbq !== "undefined") {
        fbq("track", "InitiateCheckout");
      }
      if (typeof ttq !== "undefined") {
        ttq.track("InitiateCheckout");
      }

      $players.empty();
      $players.addClass("form-default");
      $players.append($("<option/>", { text: "Number of " + slot.room.playerLabel, value: 0 }));

      var maximumNumber = slot.data.free < slotSizes.maxGroupSize ? slot.data.free : slotSizes.maxGroupSize;
      var minPlayersFixedPrice = dataModule.resolveMinPlayersFixedPrice(room, selectedEventId) || 0;
      $(".text-player-label").text(slot.room.playerLabel);
      for (var x = minimumNumber; x <= maximumNumber; x++) {
        var selectFirst = x == minimumNumber && slot.room.playerSelectFirst;
        if (selectFirst) {
          state.players = x;
        }
        var value = x === 1 ? slot.room.playerValue : slot.room.playerValuePlural;
        var text = x + " " + value;
        if (x >= privateRoomPlayers && slot.data.orders === 0 && slot.room.private !== false) {
          text = x + " " + value + " (Private)";
        }
        if (x > minPlayersFixedPrice && minPlayersFixedPrice > 0) {
          text = x + " " + value + " (No extra cost)";
        }
        var $option = $("<option/>", { value: x, text: text, selected: String(x) === state.players || selectFirst });
        $players.append($option);
      }

      if (state.players) {
        $players.val(state.players);
      }
      if ($players.val() !== "0") {
        $players.removeClass("form-default");
      }

      var $custom = $(".custom-row");
      $custom.empty();

      var customFields = resolve.resolveReservationCustom(slot.event, selectedEventId);
      if (customFields.length > 0) {
        var $customRow = $([]);
        customFields.forEach(function (custom) {
          if (
            custom.values === null ||
            ["discount", "promo", "virtual experience"].indexOf(custom.name.toLowerCase()) > -1 ||
            custom.name.toLowerCase().indexOf("promo") > -1 ||
            custom.name.toLowerCase().indexOf("hide") > -1
          ) {
            return;
          }
          var values = custom.values.map(function (value) {
            return "<option>" + value + "</option>";
          });
          values.unshift('<option value="">Select ' + custom.name + "</option>");

          var $select = $('<select name="custom-' + custom.id + '" class="custom-select form-custom form-default form-custom-' + custom.id + '">' + values + "</select>");
          var $name = $("<strong>" + custom.name + "</strong>");
          var $moreInfo = null;
          var fieldInfo = findCustomFieldInfo(slot.room, custom.name);
          if (fieldInfo) {
            $moreInfo = $('<button type="button" class="more-info text-sm">' + window.EM_ICONS.svg("info-circle") + " More Info</button>");
            $moreInfo.on("click", function () {
              openCustomFieldInfoModal(fieldInfo);
            });
          }
          $customRow = $customRow.add($('<div class="col-12 col-md-6"></div').append($name, $moreInfo));
          $customRow = $customRow.add($('<div class="col-12 col-md-6 text-md-right"></div>').append($select));
        });
        $custom.append($("<div/>", { class: "row" }).append($customRow)).show();
        $custom.on("change", "select", function () {
          $(this).removeClass("form-default");
        });
      } else {
        $custom.hide();
      }

      $(".booking-calendar").hide();
      $(".booking-form").show();

      state.action = "book";
      if (opt.skipUpdateUrl === false) {
        ns.url.updateUrl(cfg.PAGE_BOOK);
      }

      var sharedSlotNotice = buildSharedSlotNotice(slot);
      if (sharedSlotNotice) {
        bookNotes.unshift(sharedSlotNotice);
      }

      if (bookNotes.length > 0) {
        var bookNoteHtml = bookNotes.join("<hr/>");
        if (slot.room.acceptBookNote) {
          bookNoteHtml =
            '<div class="form-check"><input type="checkbox" class="form-check-input" id="acceptBookNote"/><label class="form-check-label" for="acceptBookNote"><strong>I acknowledge that I have read and accept the following:</strong> <span class="text-normal">' +
            bookNoteHtml +
            "</span></label></div>";
        }
        $(".info-row").show().find(".alert-message").html(bookNoteHtml);
      } else {
        $(".info-row").hide();
      }
    }
  }

  function bindHandlers() {
    $(".booking-dates").on("click", ".booking-slot", function (e) {
      var $time = $(e.currentTarget);
      var $event = $time.closest(".booking-event");
      var state = st.get();

      if ($time.hasClass("unavailable")) {
        return;
      }

      state.date = $event.attr("data-date");
      calendarReturnUrl = buildCalendarReturnUrl(state.date);
      state.time = $time.attr("data-time");
      state.venue = parseInt($event.attr("data-venue"));
      state.event = parseInt($time.attr("data-event") || $event.attr("data-event"));

      var slotTime = moment.tz(state.date + " " + state.time, "YYYYMMDD HH:mm", cfg.VENUE_TZ);
      if (slotTime.hour() <= 4) {
        slotTime.add(1, "day");
      }
      if (slotTime.isBefore(cfg.NOW)) {
        alert("Sorry, that slot is no longer available.");
        return;
      }
      var openTableId = $time.attr("data-open-table");
      if (openTableId) {
        $(document.body).addClass("fixed");
        var openTableUrl = "https://www.opentable.com/restref/client/?restref=" + openTableId + "&datetime=" + slotTime.format("YYYY-MM-DD") + "T" + slotTime.format("HH:mm") + "&covers=2";
        var $openTable = $(document.body).append(
          '<div class="open-table"><div class="cancel"><a class="link-cancel"><img src="/images/icon-close.png" /></a></div><iframe src="' + openTableUrl + '"></iframe></div>',
        );
        $openTable.on("click", ".link-cancel", function () {
          $(document.body).removeClass("fixed");
          $(".open-table").remove();
        });
        return;
      }

      showBook();
    });

    $(".booking-form").on("click", ".link-cancel", function () {
      var state = st.get();
      window.location = calendarReturnUrl || cfg.PAGE_CALENDAR + "?start=" + encodeURIComponent(state.date);
    });

    $(".form-players").on("change", function () {
      var $input = $(this);
      var state = st.get();
      state.players = parseInt($input.val());
      ns.url.updateUrl(cfg.PAGE_BOOK, true);

      if (state.players === "0") {
        $input.addClass("form-default");
      } else {
        $input.removeClass("form-default");
      }

      showBook({ refreshHtmlOnly: true });
    });

    $(".booking-form .button-complete").on("click", function (e) {
      e.preventDefault();
      utils.hideAlert();

      if (st.isBookingProcessing()) {
        return;
      }

      var previousCompleteText = $(this).text();
      var $button = $(this).html('<span class="position-relative d-inline-block">Processing<span>');
      var spinner = new Spinner($.extend(true, {}, DEFAULT_SPIN_OPTS, { color: "#000", scale: 0.2, top: "11px", left: "-20px" })).spin($button.find("span")[0]);
      st.setBookingProcessing(1);

      function stopSpinning() {
        spinner.stop();
        $button.html(previousCompleteText);
      }

      var state = st.get();
      var slot = dataModule.getSelectedTimeSlot();

      var selectedEventId = resolve.resolveSelectedEventId(state.event, slot.event);
      var customFields = resolve.resolveReservationCustom(slot.event, selectedEventId);
      var payload = {
        image: roomBackgroundUrl(slot.room),
        venueId: slot.location.venueId,
        eventId: selectedEventId,
        date: parseInt(state.date),
        time: state.time,
        persons: state.players || 0,
        orders: slot.data.orders,
        price: slot.event.reservation.prices.price,
        isLounge: cfg.isLounge,
        camp: cfg.isCamp,
        locationEvent: cfg.isLocationEvent ? cfg.EVENT_NAME : null,
        custom: [],
      };

      if (payload.persons === 0) {
        utils.showAlert("Please choose the number of " + slot.room.playerLabel + " before booking.");
        stopSpinning();
        st.setBookingProcessing(0);
        return;
      }

      if (customFields.length > 0) {
        for (var x = 0; x < customFields.length; x++) {
          var custom = customFields[x];
          if ($(".form-custom-" + custom.id).val() === "") {
            utils.showAlert(custom.name + " must be selected.");
            stopSpinning();
            st.setBookingProcessing(0);
            return;
          }
        }
      }

      if (slot.room.acceptBookNote && $("#acceptBookNote:checked").length === 0) {
        utils.showAlert("Please acknowledge that you have read the booking notice.");
        stopSpinning();
        st.setBookingProcessing(0);
        return;
      }

      if (customFields.length > 0) {
        customFields.forEach(function (custom) {
          var $custom = $(".form-custom-" + custom.id);
          if ($custom.length === 1) {
            payload.custom.push({
              id: custom.id,
              name: custom.name,
              value: $custom.val(),
            });
          }
        });
      }

      var url = "/" + site + "/cart/add";
      if (KIOSK_MODE) {
        url = kioskPath + "/cart/add";
      }

      $.ajax({
        method: "post",
        url: url,
        data: JSON.stringify(payload),
        cache: false,
        dataType: "json",
        contentType: "application/json",
        success: function (response) {
          if (response.success === 0) {
            st.setBookingProcessing(0);
            utils.showAlert(response.message);
            stopSpinning();
            return;
          }

          stopSpinning();
          st.setBookingProcessing(0);

          if (KIOSK_MODE) {
            return (window.location = kioskPath + "/cart");
          }
          window.location = "/" + site + "/cart";
        },
        error: function (xhr) {
          if (xhr && xhr.status === 403) {
            utils.showAlert("Your session expired. Please refresh the page and try again.");
          } else {
            utils.showAlert("There was a connection error. Please try again.");
          }
          st.setBookingProcessing(0);
          stopSpinning();
        },
      });
    });
  }

  ns.book = {
    showBook: showBook,
    bindHandlers: bindHandlers,
  };
})(window.EM.booking);
